import { Injectable } from '@angular/core';

import * as toastr from 'toastr';

/*
  Generated class for the IonicAngularProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IonicAngularProvider {

  private loading : any;

 

  constructor(
    
    
    ) {
    console.log('Hello IonicAngularProvider Provider');
  }

  toast(message: string, position: string = 'bottom', duration: any = 2,  showCloseButton: boolean = false, closeButtonText: string = '') {
    if(duration < 2) {
      duration = 2;
    }
    /*let toast = this.toastCtrl.create({
          message: message,
          position: position,
          duration: showCloseButton ? null : duration * 1000,
          showCloseButton: showCloseButton,
          closeButtonText: closeButtonText,
          cssClass: 'custom-toast'
    });
    toast.present();*/
    //alert(message);
    toastr.options = {
      "closeButton": true,
      "debug": false,
      "newestOnTop": false,
      "progressBar": false,
      "positionClass": "toast-bottom-right",
      "preventDuplicates": false,
      "onclick": null,
      "showDuration": "300",
      "hideDuration": "1000",
      "timeOut": "5000",
      "extendedTimeOut": "1000",
      "showEasing": "swing",
      "hideEasing": "linear",
      "showMethod": "fadeIn",
      "hideMethod": "fadeOut"
    };
    toastr.error(message);
  }

  showLoading(message: string = 'Cargando...', duration: number = 20) {

    if(this.loading) {
      this.hideLoading();
    }

    /*this.loading = this.loadingCtrl.create({
      content: message,
      cssClass: "loading-custom"
    });
    this.loading.present();

    setTimeout(() => {
      this.hideLoading();
    }, duration *1000);*/
    console.log('Cargando');
  }

  hideLoading() {
    if(this.loading) {
      this.loading.dismiss();
    }
  }

  
}



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/providers/ionic-angular/ionic-angular.ts